const POST_SIGNUP_ATHLETE_CODE_KEY = "waypoint:post-signup-athlete-code-prompt";

export function markPostSignupAthleteCodePromptPending() {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(POST_SIGNUP_ATHLETE_CODE_KEY, "pending");
}

export function clearPostSignupAthleteCodePrompt() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(POST_SIGNUP_ATHLETE_CODE_KEY);
}

export function hasPendingPostSignupAthleteCodePrompt(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(POST_SIGNUP_ATHLETE_CODE_KEY) === "pending";
}
